// extracted by mini-css-extract-plugin
module.exports = {"title":"IngredientsPage_title__WTqSl","container":"IngredientsPage_container__33xXT"};